import {
  action, flow, makeObservable, observable,
} from 'mobx';

import BaseStore from './BaseStore';
import AnnoncesSearchResultApi from '../api/annonces_search_result_api';

const ANNONCES_PER_PAGE = 10;

class AnnoncesSearchResultStore extends BaseStore {
  isLoading = false;
  annonces = [];
  page = 1;
  total = 0;
  latitude;
  longitude;
  selectedCategory;

  constructor() {
    super();

    makeObservable(this, {
      isLoading: observable,
      annonces: observable,
      page: observable,
      total: observable,
      latitude: observable,
      longitude: observable,
      selectedCategory: observable,
      setPage: action.bound,
      setLatitude: action.bound,
      setLongitude: action.bound,
      setCategory: action.bound,
    });
  }

  getAnnonces = flow(
    function* () {
      this.isLoading = true;

      try {
        const { data: { items, total } } = yield AnnoncesSearchResultApi.getAnnonces({
          latitude: this.latitude,
          longitude: this.longitude,
          category: this.selectedCategory,
          limit: ANNONCES_PER_PAGE,
          page: this.page,
        });
        this.annonces = items;
        this.total = total;
      } finally {
        this.isLoading = false;
      }
    },
  );

  setPage(page) {
    if (page !== this.page) {
      this.page = page;
      this.getAnnonces();
    }
  }

  setLatitude(latitude) {
    this.latitude = latitude;
  }

  setLongitude(longitude) {
    this.longitude = longitude;
  }

  setCategory(category) {
    this.selectedCategory = category;
  }

  get pageCount() {
    return Math.ceil(this.total / ANNONCES_PER_PAGE);
  }
}

export default new AnnoncesSearchResultStore();
